import * as React from 'react';

import ConfiguredTabListInformationCard from 'bundles/enterprise-legacy-learner-home/components/InformationCard/ConfiguredTabListInformationCard';
import type { InformationCardProps } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';

import { getHowSkillSetsWorkConfig } from './content';

type HowSkillSetsWorkInformationCardProps = InformationCardProps;

const HowSkillSetsWorkInformationCard: React.FC<HowSkillSetsWorkInformationCardProps> = ({ ...props }) => {
  const config = getHowSkillSetsWorkConfig();

  return <ConfiguredTabListInformationCard config={config} {...props} />;
};

export default HowSkillSetsWorkInformationCard;
